import React from 'react'
import { convertIntoLakh } from '../UtilityComponents/UtilityFunction'

const ShowInvestment = ({showTxt, showAmt, showYrs}) => {
  return (
    <>
      <div className='box'>
        <ul>
            <li>{showTxt}</li>
                  <li className='bold'>₹{convertIntoLakh(showAmt)}</li>
            <li>{showYrs}</li>
        </ul>
      </div>
    </>
  )
}

export default ShowInvestment
